module.exports = __webpack_public_path__ + "assets/img/bottomBg.66d8fa15.png";